import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { FormServices } from 'src/app/services/form.services';
import { FormulaServices } from 'src/app/services/formula.service';
import { SnackbarService } from 'src/app/services/snackbar.service';


export interface FormArrayConfiguration{
    name:string;
    title:string;
    description:string;
    tooltip:string;
    type:string;
    required?:boolean;
    defaultValue?:any;
    maxLength?:number;
    minLength?:number;
    options?:FormArrayConfigurationOption[],
    optionsHideKey?:boolean,
    enableDisableFunction?:Function;
}

export interface FormArraySaving{
    index:number;
    parentForm:FormGroup;
    form:FormGroup;
    new?:boolean;
}

export interface FormArrayRemoving extends FormArraySaving{
  
}

export interface FormArrayCanceling extends FormArraySaving{
  
}

export interface FormArrayEditData{
    index:number;
    data:Object;
}

export interface FormArrayConfigurationOption{
    key:any;
    value:string;
}

@Component({
    selector: 'form-array-component',
    templateUrl: './form-array-component.component.html',
    styleUrls: ['./form-array-component.component.scss'],
    standalone: false
})
export class FormArrayComponentComponent implements OnInit, OnChanges {

  @Input()filter:boolean = false;
  @Input()title:string;
  @Input()formulario:FormGroup<any>;
  @Input()nomeArray:string = 'formArray';
  @Input()formConfiguration:FormArrayConfiguration[]
  @Input()showAddButton:boolean = true;
  @Input()showSaveButton:boolean = true;
  @Input()showCancelButton:boolean = true;
  @Input()arrayData:Object[] = [];
  @Input()editData:FormArrayEditData;
  @Output()saving:EventEmitter<FormArraySaving> = new EventEmitter();
  @Output()removing:EventEmitter<FormArrayRemoving> = new EventEmitter();
  @Output()canceling:EventEmitter<FormArrayCanceling> = new EventEmitter();
  controles:Observable<FormControl[]> = new Observable<FormControl[]>();
  visible = true;
  selectable = true;
  removable = true;

  selectedIndex: number = -1;
  showRemoveButton:boolean = false;
  
  getControls(index){
    
    if ( this.filter ){
      this.controles =  of<FormControl[]>([ this.array.at(index) as FormControl] ) ;
    }else{
      this.controles =  of<FormControl[]>(this.array.controls as FormControl[] ) ;
    }
  }

  constructor(private formBuilder:FormBuilder,
    private formulaServices:FormulaServices,
    private formServices:FormServices,
    private snackServices:SnackbarService) { }
  
  
  ngOnChanges(changes: SimpleChanges): void {
    
    if ( changes.editData != null && changes.editData.currentValue != null ){
      let newValue:FormArrayEditData = changes.editData.currentValue;
      if ( newValue!= null && newValue.index > -1 ){
        this.selectedIndex = newValue.index;
        this.getControls(newValue.index);
      }else{
        this.addItemArrayItem();
        let index = this.array.length - 1
        this.selectedIndex = index;
        this.getControls(index);
      }
    }
  }

  getChipFormControl(index,name){
    if ( this.array.at(index) != null ){
      return this.array.at(index).get(name) as FormControl;
    }else{
      return null;
    }
    
  }

  ngOnInit(): void {

    if (this.showAddButton && !this.filter){
      this.addItemArrayItem();
      this.getControls(null);
    }else{
      (this.formulario.get(this.nomeArray) as FormArray).clear({emitEvent:false});
      this.arrayData.forEach((val,index)=>{
        this.addItemArrayItem();
        this.loadEditData(val,index);
      });  
    }
  }

  loadEditData(val,index){
    let form:FormGroup =  (this.formulario.get(this.nomeArray) as FormArray).at(index) as FormGroup;
    if ( val!= null ){
      this.formServices.refreshFormObject(form,val);
    }else{
      this.formServices.refreshFormObject(form,this.editData.data);
    }
    
    return form;
  }
  
  addItemArrayItem() {

      const item = this.formBuilder.group({});
      this.formConfiguration.forEach(data=>{
          if ( data.type == 'chips'){
            item.addControl(data.name, new FormControl<string[]>([]));
          }else{
            item.addControl(data.name, new FormControl<any>(null));
          }
          
          if ( data.required ){
            item.get(data.name).addValidators(Validators.required);
          }

          if ( data.maxLength!= null && data.maxLength > 0 ){
            item.get(data.name).addValidators(Validators.maxLength(data.maxLength));
          }

          if ( data.minLength != null && data.minLength >0 ){
            item.get(data.name).addValidators(Validators.maxLength(data.minLength));
          }

          if ( data.enableDisableFunction != null ){
            this.formulario.valueChanges.subscribe((d:FormGroup)=>{
                let retorno:boolean  = data.enableDisableFunction.call(data.enableDisableFunction,item);
                if ( retorno ){
                  item.get(data.name).enable({emitEvent:false,onlySelf:true});
                }else{
                  item.get(data.name).disable({emitEvent:false,onlySelf:true});
                }
            });
          }
      });
      
      (this.formulario.get(this.nomeArray) as FormArray).push(item);

      return item;
  }

  addNew(){
    this.addItemArrayItem();
  }

  get array() {
    return this.formulario.get(this.nomeArray) as FormArray;
  }


  openFormula(inp, type, formGroup:UntypedFormGroup){
    
    let params:Variable[] = [];
    this.formulaServices.openFormula(inp,params).then(f=>{
        formGroup.get(type).setValue(f);
    });
  }


  selected(i:number){
     this.selectedIndex = i;
  }

  remove(index){
    if ( this.filter ){
      index = this.selectedIndex;
    }
    this.showRemoveButton =! this.showRemoveButton;
    const item:FormGroup = (this.formulario.get(this.nomeArray) as FormArray).at(index) as FormGroup;
    this.removing.next({index:index,parentForm:this.formulario,form:item});
    (this.formulario.get(this.nomeArray) as FormArray).removeAt(index);
  }

  save(index:number){
    if ( this.filter ){
        index = this.selectedIndex;
    }
    const item = (this.formulario.get(this.nomeArray) as FormArray).at(index) as FormGroup;

    if ( item.invalid ) {
      this.snackServices.showError(this.formServices.getFormErrors(item,this.formConfiguration.map(d=>{ return  {colName:d.name,colDesc:d.title}})));
      return;
    }
    if ( this.filter ){
      if ( this.editData != null && this.editData.index>-1 ){
        this.saving.next({index:this.editData.index,parentForm:this.formulario,form:item,new:false});
      }else{
        this.saving.next({index:this.selectedIndex,parentForm:this.formulario,form:item,new:true});
      }
    }else{
      this.saving.next({index:index,parentForm:this.formulario,form:item,new:true});
    }

    
  }

  cancel(index){
    const item = (this.formulario.get(this.nomeArray) as FormArray).at(index) as FormGroup;
    
    if ( this.filter ){
      //item.reset();
      if ( this.editData != null && this.editData.index>-1 ){
        this.canceling.next({index:this.editData.index,parentForm:this.formulario,form:item,new:false});
      }else{
        this.canceling.next({index:this.editData.index,parentForm:this.formulario,form:item,new:true});
       
       (this.formulario.get(this.nomeArray) as FormArray).removeAt(index);
      }
    }else{
      this.canceling.next({index:index,parentForm:this.formulario,form:item,new:true});
    }
  }

  itemClick(evento:MouseEvent, i:number){
    this.selectedIndex = i;
    evento.stopPropagation();
  }

  }
